import * as tools from '../utils/tools';
import * as TYPES from '../utils/dvtypes';
import {LayoutDefAlignments} from '../utils/dvtypes';
import {ImageSourceTypes} from "../utils/dvtypes";

export default {
    captureReportSections: function(mvc){
        if (mvc.formController == null || mvc.formController.uiControl == null){
            console.warn('Cannot capture report layout if view is not open as visible.. Aborting capture.');
            return;
        }

        let pageBreakOffset = 0;        // This sums the total height of the page breaks so their offset can be applied to controls below...EK

        //Find the Page Area defined on the view...EK
        function findSection(fromPanel, name){
            if (fromPanel == null) return null;

            if (fromPanel.typeName === 'zebra.ui.dvGroupPanel'
                && fromPanel.definition != null
                && fromPanel.definition.Name.toLowerCase() === name) {
                //Found it!  Return the reference...EK
                return fromPanel;
            }
            else {
                for(let i = 0, iMax = fromPanel.kids.length; i < iMax; i++){
                    let foundPanel = findSection(fromPanel.kids[i], name);
                    if (foundPanel != null) return foundPanel;
                }
            }
        }


        /**
         * Find the group sections in the print area.
         * @param fromPanel The panel to look at
         * @param type The type of group section "dvCore.groupHeaderSection" or "dvCore.groupFooterSection"
         * @param propertyID  The property if of the group
         * @returns {*}
         */
        function findGroupSection(fromPanel, type, propertyID){
            if (fromPanel == null) return null;
            return fromPanel.kids.find(kid => kid.definition && kid.definition.Type.toLowerCase() === type.toLowerCase() && kid.definition.PropertyID.UID === propertyID.UID);
        }

        /**
         * capture the layout of each of the group sections.
         * @param reportSections The Report sections to add to
         * @param reportGroups The report groups to look at.
         * @returns {*} The captured report sections.
         */
        function captureGroupSections(reportSections, reportGroups){
            if (reportGroups == null) return null;

            //Loop through the groups to get the group sections.
            reportGroups.forEach((group) => {
                //Get the groups header and footer report captured section
                let headerSection = captureSection({}, findGroupSection(printArea, 'dvCore.groupHeaderSection', group.PropertyID));
                let footerSection = captureSection({}, findGroupSection(printArea, 'dvCore.groupFooterSection', group.PropertyID));

                //Create the group section
                let groupSection = { PropertyID: group.PropertyID, Header: headerSection, Footer: footerSection };
                reportSections.push(groupSection);
            });

            return reportSections;
        }

        function captureSection(reportSection, sectionPanel) {
            if (sectionPanel == null) return null;

            pageBreakOffset = 0;        // Reset the offset for this section...EK

            if (reportSection.Height == null) {
                if (sectionPanel.groupHeader != null) {
                    let headerHeight = sectionPanel.groupHeader.height + sectionPanel.top + sectionPanel.bottom;
                    reportSection.Height = sectionPanel.expandState ? sectionPanel.height + (sectionPanel.groupHeader.isVisible ? - headerHeight : 0) : 0;
                }
                else {
                    reportSection.Height = sectionPanel.height;
                }
                reportSection.Controls = [];
            }

            // Start the recursive capture of this section's controls...EK
            if (sectionPanel.groupHeader != null) {
                // we have to split this conditional to prevent capturing kids if has a group header but expand state is false.
                if (sectionPanel.expandState) {
                    sectionPanel.kids.forEach(p => captureSectionControl(reportSection, sectionPanel, p));
                }
            }
            else {
                sectionPanel.kids.forEach(p => captureSectionControl(reportSection, sectionPanel, p));
            }

            reportSection.Height -= pageBreakOffset;        // Ensure that the height of this section accounts for removed page break height...EK
            return reportSection;
        }

        function getControlTopLeftInSection(sectionPanel, controlPanel) {
            let top = 0,
                left = 0;
            if (sectionPanel.groupHeader != null) {
                top = (sectionPanel.groupHeader.isVisible ? -(sectionPanel.groupHeader.height + sectionPanel.top) : 0);  // Be sure that the header doesn't push things down...EK
            }
            let result = { left: left, top: top };

            if (controlPanel != null) {
                while (controlPanel.parent != null && controlPanel !== sectionPanel) {
                    result.top += controlPanel.y;
                    result.left += controlPanel.x;
                    controlPanel = controlPanel.parent;
                }
            }

            result.top -= pageBreakOffset;

            return result;
        }

        function captureSectionControl(reportSection, sectionPanel, controlPanel) {
            if (controlPanel.mvc != null){
                // For now: If we find a view, we stop and don't capture child views...EK
                return;
            }

            let reportControl = null;
            let defToCheck = controlPanel.definition;

            switch (controlPanel.typeName) {
                case 'zebra.ui.dvItemGroupPanel':
                case 'zebra.ui.dvGroupPanel':
                    // This is a group of items... Loop through the children running this capture process...EK
                    reportControl = captureControlGroup(sectionPanel, controlPanel, true);
                    break;
                case 'zebra.ui.dvLayoutItem':
                    //Legacy non-typed form item, determine type based on settings set in the definition...EK
                    if (defToCheck.PropertyID != null) {
                        // Fields are captured as control groups so the label and field are kept together as needed...EK

                        // If we have an existing control group with no controls, then just push to the existing group...EK
                        if (reportSection.Type === 'controlGroup' || reportSection.Type === 'image') {
                            // Capture this field and push directly to the section...EK
                            if (defToCheck.Name != null && defToCheck.Name !== '') {   // Only capture if the field label has a value...EK
                                reportSection.Controls.push(captureLabel(sectionPanel, controlPanel));
                            }
                            reportSection.Controls.push(captureField(sectionPanel, controlPanel));
                        }
                        else {
                            // We don't have a control group, create one to contain this panel...EK
                            reportControl = captureControlGroup(sectionPanel, controlPanel, false);
                            if (defToCheck.Name != null && defToCheck.Name !== '') {   // Only capture if the field label has a value...EK
                                reportControl.Controls.push(captureLabel(sectionPanel, controlPanel));
                            }
                            reportControl.Controls.push(captureField(sectionPanel, controlPanel));
                        }
                    }
                    else if (defToCheck.IsLabel) {
                        if (reportSection.Type === 'controlGroup' || reportSection.Type === 'image') {
                            reportSection.Controls.push(captureLabel(sectionPanel, controlPanel));
                        }
                        else {
                            // We don't have a control group, create one to contain this panel...EK
                            reportControl = captureControlGroup(sectionPanel, controlPanel, false);
                            reportControl.Controls.push(captureLabel(sectionPanel, controlPanel));
                        }
                    }
                    else if (defToCheck.Image != null) {
                        if (reportSection.Type === 'controlGroup' || reportSection.Type === 'image') {
                            reportSection.Controls.push(captureImage(sectionPanel, controlPanel));
                        }
                        else {
                            // We don't have a control group, create one to contain this panel...EK
                            reportControl = captureControlGroup(sectionPanel, controlPanel, false);
                            reportControl.Controls.push(captureImage(sectionPanel, controlPanel));
                        }
                    }
                    else if (defToCheck.ViewID != null ) {
                        if (defToCheck.ViewID.UID === mvc.drivingView.UID) {
                            reportControl = captureGrid(sectionPanel, controlPanel);
                            reportSection.Height = reportControl.Height;        //Since this is a grid detail row, the section and detail row must be the same size...EK
                        }
                        // else: ignore, do not capture (invalid config that will be cleaned the next time this loads)...EK
                    }
                    else if (defToCheck.ReportID != null ) {
                        reportControl = captureSubReport(sectionPanel, controlPanel);
                    } else if(defToCheck.Type === 'dvCore.pageBreak') {
                        reportControl = capturePageBreak(sectionPanel, controlPanel);
                    } else {
                        console.warn(`Unhandled Layout control type: ${controlPanel.typeName}`);
                    }
                    break;
                default:
                    if (controlPanel.typeName !== 'zebra.ui.dvGroupPanelButton') {
                        console.warn(`Unhandled control type: ${controlPanel.typeName}`);
                    }
            }

            if (reportControl != null) {
                //Add the control ID if labeled.
                if(defToCheck && defToCheck.ID) {
                    reportControl.ID = defToCheck.ID;
                }
                reportSection.Controls.push(reportControl);
            }
        }

        function cleanFontName(fontName) {
            try {
                //Font name may be wrapped in quotes, just return the internal value...EK
                if (fontName.startsWith('"') || fontName.startsWith("'")){
                    // Trim off the quotes...EK
                    fontName = fontName.slice(1);
                }
                if (fontName.endsWith('"') || fontName.endsWith("'")){
                    // Trim off the quotes...EK
                    fontName = fontName.slice(0, fontName.length - 1);
                }

                fontName = fontName.toLowerCase();
                switch (fontName){
                    case 'fixed':
                    case 'monospace':
                    case 'terminal':
                    case 'courier':
                        fontName = 'courier';
                        break;
                    case 'times':
                        fontName = 'times';
                        break;
                    default:
                        fontName = 'helvetica';
                        break;
                }
                return fontName;
            }
            catch (e) {
                return fontName;
            }
        }

        function captureBorder(capturePanel, reportControl){
            if (capturePanel.border != null) {
                if (capturePanel.border.color != null && capturePanel.border.color.toString().startsWith('#'))
                    reportControl.Style.borderColor = tools.parseHexToRBG(capturePanel.border.color);
                else {
                    //This is an invalid color and must be hex (for now) ... EK
                    reportControl.Style.borderColor = {r: 0, g: 0, b: 0};
                    console.warn('Invalid color specified: ' + capturePanel.border.color.toString() + '. Must be in Hex for reports. Defaulted to black.')
                }
                reportControl.Style.borderWidth = capturePanel.border.width;
                reportControl.Style.borderRadius = capturePanel.border.radius;
            }
        }

        function captureBackground(capturePanel, reportControl){
            if (capturePanel.bg != null){
                if (zebra.instanceOf(capturePanel.bg, zebra.ui.dvPicture)) {
                    let color = capturePanel.bg.color;
                    if (color != null) {
                        if (typeof color == 'string'){
                            reportControl.Style.background = tools.parseHexToRBG(color);
                        }
                        else {
                            reportControl.Style.background = { r: color.r, g: color.g, b: color.b };
                        }

                    }
                    // otherwise, no color to capture...
                }
                else {
                    if (capturePanel.bg.s != null && capturePanel.bg.s.toString().startsWith('#'))
                        reportControl.Style.background = tools.parseHexToRBG(capturePanel.bg.s);
                    else {
                        reportControl.Style.background = {
                            r: capturePanel.bg.r,
                            g: capturePanel.bg.g,
                            b: capturePanel.bg.b
                        };
                    }
                }
            }
        }

        function captureField(sectionPanel, controlPanel) {
            // Capture the actual field that they embedded, need to capture by type (textbox for now) .. EK
            let fieldControl = null,
                pos = null;

            if (controlPanel.textField != null) {
                pos = getControlTopLeftInSection(sectionPanel, controlPanel.textField);
                fieldControl = controlPanel.textField;
                if (fieldControl.dateTimeField != null){
                    fieldControl = fieldControl.dateTimeField;      // For some reason, dates are nested this way.. drill down to it's reference...EK
                }
            }
            else if (controlPanel.comboBox != null){
                pos = getControlTopLeftInSection(sectionPanel, controlPanel.comboBox);
                fieldControl = controlPanel.comboBox.content.textField;
            }
            else {
                console.warn('Unhandled field type on report capture.');
                return null;
            }

            var reportControl = {
                Type: 'label',
                Style: {
                    padding: 0
                },
                Left: pos.left,
                Width: fieldControl.width,
                Height: controlPanel.height,
                Top: pos.top
            };

            //Get the display format if there is any...
            if (controlPanel.dvProperty && controlPanel.dvProperty.Definition.DisplayFormat) {
                reportControl.DisplayFormat = controlPanel.dvProperty.Definition.DisplayFormat;
            }

            //Since this is a field, we need to bind it on the property...EK
            reportControl.Expression = '[' + controlPanel.definition.PropertyID.UID + ']';

            reportControl.Style.fontName = cleanFontName(fieldControl.view.font.name.split(',')[0]);
            reportControl.Style.fontSize = fieldControl.view.font.size;
            reportControl.Style.fontWeight = fieldControl.view.font.style;

            if (fieldControl.view.color != null && fieldControl.view.color.toString().startsWith('#'))
                reportControl.Style.color = tools.parseHexToRBG(fieldControl.view.color);
            else {
                //This is an invalid color and must be hex (for now) ... EK
                console.warn('Invalid color specified: ' + fieldControl.view.color.toString() + '. Must be in Hex for reports. Defaulted to black.')
                reportControl.Style.color = {r: 0, g: 0, b: 0};
            }

            //NOTE: Currently v1 we don't capture background or border of fields... Users must use a bound label to do this...EK

            return reportControl;
        }

        function captureLabel(sectionPanel, controlPanel) {
            let capturePanel = null,
                alignment = null;           // Default to null (left).  jsPDF requires null for left alignment...EK
            if (controlPanel.definition.IsLabel){
                capturePanel = controlPanel;
                //If the textAlign property is defined, use it...BC

                if (capturePanel.textLabel.view.textAlign === TYPES.HorizontalTextAlignment.Center) {
                    alignment = 'center';
                }
                else if (capturePanel.textLabel.view.textAlign === TYPES.HorizontalTextAlignment.Right) {
                    alignment = 'right';
                }

                //Else it will remain null which is left...BC
            }
            else {
                //We are capturing a field, so only look at the text label...EK
                capturePanel = controlPanel.textLabel;
                // Note: Since we are capturing a field, the text alignment of the label is always 'left' ... EK
            }

            if (controlPanel.definition.Name != null && controlPanel.definition.Name.toString().toLowerCase() === '##line') {
                return captureLine(sectionPanel, controlPanel)
            }

            var pos = getControlTopLeftInSection(sectionPanel, capturePanel);

            var reportControl = {
                Type: 'label',
                Style: {
                    padding: 0,
                    textAlign: alignment
                },
                Left: pos.left,
                Width: capturePanel.width,
                Height: capturePanel.height,
                Top: pos.top
            };

            //Capture the content this label should show (either static text or it is bound to an expression) ... EK
            //Note: always the controlPanel ref here...EK

            // Legacy reports will have a ? at the beginning which means it is an expression...EK
            if (controlPanel.definition.Name != null && controlPanel.definition.Name.startsWith('?')) {
                reportControl.Expression = controlPanel.definition.Name.substring(1);
            }
            else if (controlPanel.definition.Expr != '') {
                reportControl.Expression = controlPanel.definition.Expr;
            }

            //Add the display format for the label
            if (controlPanel.definition.DisplayFormat != null){
                reportControl.DisplayFormat = controlPanel.definition.DisplayFormat;
            }

            if (reportControl.Expression) {
                //If this contains page info, update the control type...EK
                if (reportControl.Expression.indexOf('##PageNumber') > -1
                    || reportControl.Expression.indexOf('##PageCount') > -1) {
                    reportControl.Type = 'pageInfo';
                }
            }
            else {
                if(controlPanel.textLabel){
                    //if this is a textLabel get the target for the value (the value displayed to the user)...BC
                    reportControl.Text = controlPanel.textLabel.view.target;

                    //If this is multiLine text, we have to get each line and concatenate to a single string.
                    //Otherwise the 'Text' property will have a parent refernce and can't be stringified...BC
                    if(reportControl.Text && reportControl.Text.lines){
                        let tempTxt = "";
                        //Loop through each line
                        for ( let i = 0, il = reportControl.Text.lines.length; i < il; i++ ){
                            let ln = reportControl.Text.lines[i]
                            tempTxt += ln.text;

                            //If there is a hard return, add the newline character...BC
                            if(ln.hardRtn === true){
                                tempTxt += "\n";
                            }
                        }
                        //Set the result to the Text property...BC
                        reportControl.Text = tempTxt;
                    }
                }
                else {
                    reportControl.Text = controlPanel.definition.Name != null ? controlPanel.definition.Name : '';
                }
            }

            //Capture the font aspects of the style...EK
            var innerLabel = (capturePanel.textLabel == null ? capturePanel : capturePanel.textLabel);
            if (innerLabel.view.font != null){
                reportControl.Style.fontName = cleanFontName(innerLabel.view.font.name.split(',')[0]);
                reportControl.Style.fontSize = innerLabel.view.font.size;
                reportControl.Style.fontWeight = innerLabel.view.font.style;

                if (innerLabel.view.color != null && innerLabel.view.color.toString().startsWith('#'))
                    reportControl.Style.color = tools.parseHexToRBG(innerLabel.view.color);
                else {
                    //This is an invalid color and must be hex (for now) ... EK
                    console.warn('Invalid color specified: ' + innerLabel.view.color.toString() + '. Must be in Hex for reports. Defaulted to black.')
                    reportControl.Style.color = {r: 0, g: 0, b: 0};
                }
            }

            //Capture the background (if specified) ... EK
            captureBackground(capturePanel, reportControl);

            //Capture the border (if specified) ... EK
            captureBorder(capturePanel, reportControl);

            return reportControl;
        }

        function captureLine(sectionPanel, controlPanel) {
            let pos = getControlTopLeftInSection(sectionPanel, controlPanel);

            return {
                Type: 'line',
                Left: pos.left,
                Width: controlPanel.width,
                Height: controlPanel.height,
                Top: pos.top
            };
        }

        function captureImage(sectionPanel, controlPanel) {
            let imgDef = controlPanel.definition;
            let pos = getControlTopLeftInSection(sectionPanel, controlPanel);
            let imgCtl = {
                Type: 'image',
                Height: controlPanel.height - (controlPanel.getTop() + controlPanel.getBottom()),         // Using imageField here to be sure we avoid any control padding around the image (aspect ratio will be off otherwise) ... EK
                Width: controlPanel.width - (controlPanel.getLeft() + controlPanel.getRight()),
                Style: {
                    padding: 0, //controlPanel.layout.gap        //  Note: keeping 0 as there is an issue with this (the form doesn't look like the PDF with this setting...EK
                    scaling: imgDef.Image.Scaling
                },
                Src: {},
                Controls: [],
                Left: pos.left,
                Top: pos.top
            };

            captureBackground(controlPanel, imgCtl);

            captureBorder(controlPanel, imgCtl);

            switch (imgDef.Image.Type) {
                case ImageSourceTypes.Property:
                    imgCtl.Src.PropertyID = imgDef.Image.PropertyID;
                    break;
                case ImageSourceTypes.Expression:
                    imgCtl.Src.Expr = imgDef.Image.Expr;
                    break;
                case ImageSourceTypes.Url:
                    imgCtl.Src.Url = imgDef.Image.Url;
                    break;
                case ImageSourceTypes.Library:
                default:
                    if (imgDef.Image.Expr != null) {
                        imgCtl.Src.Expr = imgDef.Image.Expr;
                    }
                    else if (imgDef.Image.Url != null) {
                        imgCtl.Src.Url = imgDef.Image.Url;
                    }
                    else if (imgDef.Image.PropertyID != null) {
                        imgCtl.Src.PropertyID = imgDef.Image.PropertyID;
                    }
            }

            controlPanel.kids.forEach(p => captureSectionControl(imgCtl, controlPanel, p) );

            return imgCtl;
        }

        function captureGrid(sectionPanel, controlPanel) {
            let gridCtl = controlPanel.gridController.uiGrid;

            //Capture the grid top columns in the page header section...EK
            let headerRow = {
                Type: 'tableRow',
                Height: 20, //gridCtl.topCaption.height,
                Cells: []
            };

            let detailRow = {
                Type: 'tableRow',
                Height: zebra.ui.grid.Grid.DEF_ROWHEIGHT,
                Cells: []
            };

            // Spread the non-defined column widths evenly across the page section width...EK
            let calcColWidth = 0;
            let visibleDynamicCols = gridCtl.topCaption.kids.where((col) => {
                return col.isEndSpacer === false
                    && col.isHidden === false
                    && col.dvColumn.columnProperty.DefaultWidth == null
            });

            if (visibleDynamicCols.any() === true) {
                //We need to spread each dynamic column so they fill the section width...EK
                let staticColSum = gridCtl.topCaption.kids
                    .where(col => col.dvColumn.columnProperty != null && col.dvColumn.columnProperty.DefaultWidth != null)
                    .select(col => parseInt(col.dvColumn.columnProperty.DefaultWidth))
                    .sum();

                calcColWidth = (sectionPanel.width - staticColSum) / visibleDynamicCols.length;     // Calculated the width based on the available (non-statically defined) width...EK
            }

            let colTop = sections.PageHeader.Height;            //We are appending the column headers to the bottom of the page header...EK
            let colLeft = 0;
            gridCtl.topCaption.kids.forEach((col) => {

                // Use either the defined width in the column property, or we use the calculated width from above...EK
                if (col.isHidden || col.isEndSpacer) return;     //This column is hidden.. don't include in the report definition...EK
                let colWidth = (col.dvColumn.columnProperty.DefaultWidth != null) ? parseInt(col.dvColumn.columnProperty.DefaultWidth) : calcColWidth;

                let rptCol = {
                    Type: 'label',
                    Style: {
                        borderWidth: 1,
                        borderColor: {r:50, g:50, b:50},
                        borderRadius: 0,
                        textAlign: 'center',
                        padding: 4
                    },
                    Text: col.titlePan.link.view.target.lines[0].s,
                    Left: colLeft,
                    Width: colWidth,
                    Height: 20, //gridCtl.topCaption.height,
                    Top: colTop
                };

                // capture the column header font style...EK
                let title = col.titlePan.link;
                if (col.titlePan.link.view.font != null){
                    rptCol.Style.fontName = cleanFontName(title.view.font.name.split(',')[0]);
                    rptCol.Style.fontSize = title.view.font.size;
                    rptCol.Style.fontWeight = title.view.font.style;

                    if (title.colors[2] != null && title.colors[2].toString().startsWith('#'))
                        rptCol.Style.color = tools.parseHexToRBG(title.colors[2]);
                    else {
                        //This is an invalid color and must be hex (for now) ... EK
                        console.warn('Invalid color specified: ' + title.colors[2].toString() + '. Must be in Hex for reports. Defaulted to black.');
                        rptCol.Style.color = {r: 0, g: 0, b: 0};
                    }
                }

                //Capture the column header background ... EK
                let headerBg = controlPanel.gridController.uiGrid.topCaption.bg;
                if (headerBg != null){
                    if (headerBg.s != null && headerBg.s.toString().startsWith('#'))
                        rptCol.Style.background = tools.parseHexToRBG(headerBg.s);
                    else {
                        rptCol.Style.background = {r: headerBg.r, g: headerBg.g, b: headerBg.b};
                    }
                }

                //Now capture a detail cell template for this column...EK

                let detailCol = {
                    Type: 'label',
                    Style: {
                        background: null,
                        borderWidth: 1,
                        borderColor: {r:50, g:50, b:50},
                        borderRadius: 0,
                        padding: 4
                    },
                    Expression: '[' + col.dvColumn.columnProperty.PropertyID.UID + ']',
                    Left: colLeft,
                    Width: colWidth,
                    Height: detailRow.Height,
                    Top: 0
                };

                let render = gridCtl.provider.render;
                if (render.font != null){
                    detailCol.Style.fontName = cleanFontName(render.font.name.split(',')[0]);
                    detailCol.Style.fontSize = render.font.size;
                    detailCol.Style.fontWeight = render.font.style;

                    if (render.color != null && render.color.toString().startsWith('#'))
                        detailCol.Style.color = tools.parseHexToRBG(render.color);
                    else {
                        //This is an invalid color and must be hex (for now) ... EK
                        console.warn('Invalid color specified: ' + render.color.toString() + '. Must be in Hex for reports. Defaulted to black.')
                        detailCol.Style.color = {r: 0, g: 0, b: 0};
                    }
                }

                colLeft += colWidth;
                headerRow.Cells.push(rptCol);
                detailRow.Cells.push(detailCol);
            });

            //Append the header row created to the page header...EK
            sections.PageHeader.Height += headerRow.Height;
            sections.PageHeader.Controls.push(headerRow);

            return detailRow;
        }

        function capturePageBreak(sectionPanel, controlPanel){
            var pos = getControlTopLeftInSection(sectionPanel, controlPanel);
            pageBreakOffset += controlPanel.height + controlPanel.layout.gap / 2;      // Track the offset for this view since page breaks don't actually take up space (but they do in the designer) ... EK

            return {
                Type: 'pageBreak',
                Top: pos.top,
                Left: pos.left,
            };
        }

        function captureSubReport(sectionPanel, controlPanel) {
            let pos = getControlTopLeftInSection(sectionPanel, controlPanel);
            pageBreakOffset += controlPanel.height + controlPanel.parent.layout.gap / 2;

            return {
                Type: 'subReport',
                Left: pos.left,
                Top: pos.top,
                View: controlPanel.definition.ReportID,
            };
        }

        function captureControlGroup(sectionPanel, controlPanel, recursive) {
            let pos = getControlTopLeftInSection(sectionPanel, controlPanel);
            let controlGrpDef = {
                Type: 'controlGroup',
                Left: pos.left,
                Top: pos.top,
                Width: controlPanel.width,
                Height: controlPanel.height,
                Controls: [],
                Style: {}
            };

            captureBackground(controlPanel, controlGrpDef);

            captureBorder(controlPanel, controlGrpDef);

            // Now capture all the controls within this control group...EK
            if (recursive){
                controlPanel.kids.forEach(p => captureSectionControl(controlGrpDef, sectionPanel, p) );
            }
            return controlGrpDef;
        }

        var sections = {};
        var printArea = findSection(mvc.formController.uiControl, 'print area');

        sections.Header = captureSection({}, findSection(printArea, 'report header'));
        sections.PageHeader = captureSection({}, findSection(printArea, 'page header'));
        sections.Groups =  captureGroupSections([], mvc.editView.Definition.ReportGroups);
        sections.Detail = captureSection({}, findSection(printArea, 'detail'));
        sections.PageFooter = captureSection({}, findSection(printArea, 'page footer'));
        sections.Footer = captureSection({}, findSection(printArea, 'report footer'));

        return sections;
    }
};
